/***************************************************************************************************
 ** toast
 ***************************************************************************************************/

export default function toast(message, options = {}) {
  window.dispatchEvent(
    new CustomEvent("toast", {
      detail: {
        message: message,
        type: options.type,
        duration: options.duration,
      },
    }),
  );
}
